var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResouceManagementBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users/profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6875 13.1486C10.5708 13.1369 10.4308 13.1369 10.3025 13.1486C7.5258 13.0552 5.3208 10.7802 5.3208 7.98022C5.3208 5.12189 7.6308 2.80022 10.5008 2.80022C13.3592 2.80022 15.6808 5.12189 15.6808 7.98022C15.6692 10.7802 13.4642 13.0552 10.6875 13.1486Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1453 5.13355C21.4087 5.13355 23.2287 6.96522 23.2287 9.21689C23.2287 11.4219 21.4787 13.2186 19.297 13.3002C19.2037 13.2886 19.0987 13.2886 18.9937 13.3002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.85285 17.4536C2.02952 19.3436 2.02952 22.4236 4.85285 24.3019C8.06118 26.4486 13.3229 26.4486 16.5312 24.3019C19.3546 22.4119 19.3546 19.3319 16.5312 17.4536C13.3346 15.3186 8.07285 15.3186 4.85285 17.4536Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.3965 23.8002C22.2365 23.6252 23.0298 23.2869 23.6832 22.7852C25.5032 21.4202 25.5032 19.1686 23.6832 17.8036C23.0415 17.3136 22.2598 16.9869 21.4315 16.8002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResouceManagementBlue);
export default __webpack_public_path__ + "static/media/resouce-management-blue.b2a9d5aaa75a62ded21d3041c37132e5.svg";
export { ForwardRef as ReactComponent };